<smart-card [backButton]="false" class="crud-create-wrapper" [ngClass]="{'loading': loading }">
  <ng-container navigation>
    @if (!filledForm) {
    <button class="flex-initial" mat-raised-button color="primary" navigateBack>
      <mat-icon class="materialSendIcon">arrow_back</mat-icon>
      <span class="customSendIconLeft"></span>
      <span [innerHtml]="'back' | translate | uppercase"></span>
    </button>
    } @if (filledForm) {
    <button class="flex-initial" mat-raised-button color="primary" (click)="discardSumUpForm()">
      <mat-icon class="materialSendIcon">arrow_back</mat-icon>
      <span class="customSendIconLeft"></span>
      <span [innerHtml]="'back' | translate | uppercase"></span>
    </button>
    }
  </ng-container>

  <h2 [innerHtml]="config.title | translate"></h2>
  <form (ngSubmit)="validateForm()" [formGroup]="form">
    <div [hidden]="filledForm">
      <p [innerHtml]="config.description | translate"></p>

      <formly-form
        [form]="form"
        [fields]="formFields"
        [model]="formModel"
        [options]="options"
      ></formly-form>

      <div class="d-flex justify-center">
        <button
          class="w-50"
          mat-raised-button
          color="accent"
          type="submit"
          [disabled]="!form.valid"
        >
          <span [innerText]="'forward'|translate "> </span>
          <span class="customSendIconRight"></span>
          <mat-icon class="materialSendIcon">arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </form>
  @if (filledForm) {
  <div>
    <app-form-confirm
      [filledFields]="filledForm"
      [extraConfirmFormFields]="extraConfirmFormFields"
      [translateKeyTitle]="config.confirm.title"
      [translateKeyDescription]="config.confirm.description"
      [showTicketCreateData]="false"
      (confirmed)="submit()"
      (backToEdit)="discardSumUpForm()"
    ></app-form-confirm>
  </div>
  } @if (isDevMode) {
  <pre>
      {{form.value | json}}
    </pre>
  }
</smart-card>

<spinner-overlay [show]="loading"></spinner-overlay>
